import { useState } from "react";
import { categories, newsFeed, type CateKey } from "@/mocks/gossipData";

type Filter = "all" | CateKey;

const tabs: { key: Filter; label: string }[] = [
  { key: "all", label: "全部热瓜" },
  ...categories.map((c) => ({ key: c.key as Filter, label: c.label })),
];

export default function Feed() {
  const [active, setActive] = useState<Filter>("all");
  const list = active === "all" ? newsFeed : newsFeed.filter((n) => n.cate === active);

  return (
    <section id="feed" className="bg-background-100/70 py-14 md:py-20">
      <div className="wrap">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">FRESH FEED</p>
            <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">瓜田上新</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600">
              从娱乐八卦到社会热点，点开分类即可只看你想看的那一亩地，内容持续滚动更新。
            </p>
          </div>

          <div role="tablist" aria-label="内容分类" className="flex flex-wrap items-center gap-2">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                role="tab"
                aria-selected={active === t.key}
                onClick={() => setActive(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition ${
                  active === t.key
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((n) => (
            <article
              key={n.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:-translate-y-1"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-primary-500/90 px-3 py-1 text-xs font-bold text-background-50">
                  {n.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-display text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                  {n.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{n.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {n.reads}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-message-3-line"></i>
                    {n.comments}
                  </span>
                  <span>{n.date}</span>
                  <button
                    type="button"
                    aria-label={`阅读：${n.title}`}
                    className="inline-flex items-center gap-1 whitespace-nowrap font-bold text-primary-600 transition hover:text-primary-700"
                  >
                    开吃<i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}